// @flow
import React from 'react'
import classnames from 'classnames'

type PropsT = {
  className?: string,
  fill?: string,
  stroke?: string
}

const IconAddToStory = ({ className, stroke, fill }: PropsT) => (
  <svg className={classnames('Icon IconAddToStory', className)} viewBox='0 0 32 32' xmlns='http://www.w3.org/2000/svg'>
  <g fillRule="evenodd">
      <g>
          <polygon id="add-to-story-icon" points="22 22 22 19 24 19 24 22 27 22 27 24 24 24 24 27 22 27 22 24 19 24 19 22"></polygon>
          <path d="M5,5 L15,5 L15,13 L5,13 L5,5 Z M7,7 L7,11 L13,11 L13,7 L7,7 Z" id="Combined-Shape"></path>
          <path d="M5,15 L15,15 L15,27 L5,27 L5,15 Z M7,17 L7,25 L13,25 L13,17 L7,17 Z" id="Combined-Shape"></path>
          <path d="M17,5 L27,5 L27,17 L17,17 L17,5 Z M19,7 L19,15 L25,15 L25,7 L19,7 Z" id="Combined-Shape"></path>
      </g>
  </g>
  </svg>
)

export default IconAddToStory
